import o from "./design-system.es883.js";
import l from "./design-system.es917.js";
function u(e, n, r) {
  if (n === void 0 && (n = {}), r = new o(r), n.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    r.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!r.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      r.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      r.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (r.possibleLengths())
    return s(e.phone || e.nationalNumber, r);
  if (e.countryCallingCode && r.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function s(e, n) {
  switch (l(e, n)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
export {
  u as default,
  s as isPossibleNumber
};
//# sourceMappingURL=design-system.es928.js.map
